import { Booking } from '../../../../requests-module/src';
import checkIsTnePackage from './checkIsTnePackage';
import checkIsPackageTrain from './checkIsPackageTrain';
import { ENABLE_TNE_TRANSFER } from './tneTransferFeatureFlags';

/** Regular train packages always show transfer; TNE only when ENABLE_TNE_TRANSFER is on. */
export default function shouldShowTransferTab(
    booking: Booking | null | undefined,
): boolean {
    if (!booking || !checkIsPackageTrain(booking)) {
        return false;
    }
    if (checkIsTnePackage(booking)) {
        return ENABLE_TNE_TRANSFER;
    }
    return true;
}
